module.exports = __webpack_public_path__ + "static/img/8.ae74a1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/8.png
// module id = 0uKB
// module chunks = 0